import { css, html, LitElement } from "lit"
import "../fonctionnels/ListeAmis.js"
import "../popups/PopupAjoutAmi.js"
import "../popups/PopupConnexion.js"
import "../popups/PopupMonProfil.js"
import "../popups/PopupTri.js"
import "../popups/PopupFiltre.js"
import "@luminecence/composants/PopupConfirmation"
import PopupBase from "@luminecence/composants/PopupBase"
import "../connexion/Connexion.js"
import "@luminecence/composants/BoutonIcone"
import GestionnaireChangementConnexion from "../connexion/GestionnaireChangementConnexion.js"
import { EVENEMENT_MODIFIER_AMI } from "../fonctionnels/Ami.js"
import { TRI } from "../popups/PopupTri.js"
import { naviguerVers } from "../transverse/Utilitaire.js"

export default class PagePokemonsAEchanger extends LitElement {
  static properties = {
    idCommunaute: { type: String },
    listeAmis: { type: Array },
    listeAmisAffichee: { type: Array },
    roleUtilisateur: { type: String },
  }

  static styles = css`
    :host {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          padding: 1rem;
      }

    #recherche-amis .titre h1 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span.titre {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .groupe-titre {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    #zone-connexion {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 1rem;
    }

    #zone-connexion p-bouton-icone {
      --font-size-texte: 1.5rem;
      --taille-icone-bouton: 2.5rem;
    }

    #zone-actions-recherche-amis {
        display: flex;
    }

    .liste {
      overflow: visible;
      max-height: none;
    }
  `

  /** @type {GestionnaireChangementConnexion} */
  gestionnaireChangementConnexion = null

  gestionChangementVisibilite = () => {
    if (document.visibilityState !== "visible") {
      return
    }

    const user = window.authentification.getUser()

    if (user) {
      this.chargerDonneesUtilisateur()
    } else {
      this.raz()
    }
  }

  constructor() {
    super()

    this.idCommunaute = ""
    /**
     * @type {Object[]}
     */
    this.listeAmis = []
    this.listeAmisAffichee = []
    this.roleUtilisateur = null
    this.estRechercheEnCours = false
  }

  connectedCallback() {
    super.connectedCallback()
    this.addEventListener(EVENEMENT_MODIFIER_AMI, (event) => this.modifierAmi(event))
    document.addEventListener("visibilitychange", this.gestionChangementVisibilite)
    this.chargerDonneesUtilisateur()

    this.gestionnaireChangementConnexion = window.authentification.gestionnaireChangementConnexion

    const fonctionDeclenchementCallbacksConnexion = async () => {
      await this.chargerDonneesUtilisateur()
    }
    const fonctionDeclenchementCallbacksDeconnexion = () => {
      this.raz()
    }
    this.gestionnaireChangementConnexion.callbackUtilisateurConnecte.push(fonctionDeclenchementCallbacksConnexion)
    this.gestionnaireChangementConnexion.callbackUtilisateurDeconnecte.push(fonctionDeclenchementCallbacksDeconnexion)
  }

  disconnectedCallback() {
    document.removeEventListener("visibilitychange", this.gestionChangementVisibilite)
    super.disconnectedCallback()
  }

  async chargerDonneesUtilisateur() {
    const user = window.authentification.getUser()

    if (!user) {
      return
    }
    this.communaute = await window.authentification.bdd.communautes.recupererUneCommunaute(this.idCommunaute)
    this.listeAmis = await window.authentification.bdd.pokemonsAEchanges.recupererLesPokemonsAEchangerDesAutresMembresDeCeluiConnectePourUneCommunaute(
      this.idCommunaute,
    )
    this.listeAmisAffichee = structuredClone(this.listeAmis)
    this.roleUtilisateur = await this.recupererRoleUtilisateur()
  }

  render() {
    return html`
      <span class="groupe-titre">
        <h1> ${this.communaute?.nom} </h1>
        ${this.genererActionsSelonRole()}
      </span>
      <div id="recherche-amis">
            <span class="titre">
                  <h2>Mes amis veulent échanger</h2>
                  <div id="zone-actions-recherche-amis">
                    <p-bouton-icone id="filtrer-pokemons-amis" icone="recherche" @click=${this.afficherPopupFiltre}></p-bouton-icone>
                    <p-bouton-icone id="trier-mes-amis" icone="tri" @click=${this.trierMesAmis}></p-bouton-icone>
                  </div>
            </span>
            ${this.genererListeAmis()}
        </div>`
  }

  genererListeAmis() {
    return this.listeAmisAffichee.length > 0
      ? html`<div class="liste">
                <p-liste-amis .listeAmis=${this.listeAmisAffichee} .estModeAmis=${true} @evenementAjouterMessageAUneConversation=${this.ajouterMessageAUneConversation}></p-liste-amis>
            </div>`
      : html`<span>Vous n'avez pas encore d'amis ayant des pokémons à échanger.</span>`
  }

  async recupererRoleUtilisateur() {
    return await window.authentification.bdd.communautes.recupererLeRoleDunMembreDansUneCommunaute(this.idCommunaute, window.authentification.getUser().uid)
  }

  genererActionsSelonRole() {
    if (this.roleUtilisateur === "admin") {
      return html`
        <!-- <p-bouton-icone id="editer-communaute" .icone=${"editer.svg"} @click=${(event) => this.gererCommunaute(event)}></p-bouton-icone> -->
        <p-bouton-icone id="supprimer-communaute" .icone=${"supprimer"} @click=${this.supprimerCommunaute}></p-bouton-icone>
      `
    } else if (this.roleUtilisateur === "membre") {
      return html`
        <p-bouton-icone id="quitter-communaute" .icone=${"deconnexion"} @click=${this.quitterCommunaute}></p-bouton-icone>
      `
    } else {
      return null
    }
  }

  async supprimerCommunaute() {
    const optionsPopup = {
      titre: "Confirmer la suppression de la communauté",
      texte: "Êtes-vous sûr de vouloir supprimer cette communauté ?",
    }
    const resultat = await PopupBase.ouvrirEtAttendre("p-popup-confirmation", optionsPopup)
    if (resultat) {
      window.authentification.bdd.communautes.supprimerUneCommunaute(this.idCommunaute)
      naviguerVers("/communaute")
    }
  }

  async afficherPopupFiltre(event) {
    event.stopPropagation()
    const resultat = await PopupBase.ouvrirEtAttendre("p-popup-filtre")

    if (resultat) {
      const nomPokemonRecherche = resultat.nomPokémon
      const nomAmiRecherche = resultat.nomAmi
      const estShiny = resultat.estShiny
      const estParfait = resultat.estParfait
      const raz = resultat.raz

      if (raz) {
        this.listeAmisAffichee = structuredClone(this.listeAmis)
        return
      }

      if (nomPokemonRecherche) {
        this.listeAmisAffichee = this.filtrerParPokemonRechercher(nomPokemonRecherche)
      }

      if (nomAmiRecherche) {
        this.listeAmisAffichee = this.listeAmisAffichee.filter((ami) => ami.membre.toLowerCase().includes(nomAmiRecherche.toLowerCase()))
      }

      if (estShiny) {
        this.listeAmisAffichee = this.listeAmisAffichee.map((ami) => {
          return {
            ...ami,
            echanges: ami.echanges.filter((pokemon) => pokemon.specificites.shiny),
          }
        })
      }

      if (estParfait) {
        this.listeAmisAffichee = this.listeAmisAffichee.map((ami) => {
          return {
            ...ami,
            echanges: ami.echanges.filter((pokemon) => pokemon.specificites.parfait),
          }
        })
      }
    }
  }

  filtrerParPokemonRechercher(nomPokemonRecherche) {
    const pokemonRechercheNormalise = this.normaliserTexteSansAccent(nomPokemonRecherche)

    return this.listeAmis
      .map((ami) => {
        const echangesFiltres = ami.echanges.filter((pokemon) => {
          const nomPokemonNormalise = this.normaliserTexteSansAccent(pokemon.nom)
          return nomPokemonNormalise.includes(pokemonRechercheNormalise)
        })

        if (echangesFiltres.length === 0) {
          return null
        }

        return {
          ...ami,
          echanges: echangesFiltres,
        }
      })
      .filter((ami) => ami !== null)
  }

  normaliserTexteSansAccent(texte = "") {
    return texte
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
  }

  raz() {
    this.listeAmis = []
    this.listeAmisAffichee = []
    this.roleUtilisateur = null
  }

  async trierMesAmis(event) {
    event.stopPropagation()
    const resultat = await PopupBase.ouvrirEtAttendre("p-popup-tri", {
      triAAfficher: [TRI.AZ, TRI.ZA],
    })

    if (resultat) {
      const { valeur } = resultat

      const strategiesDeTri = {
        [TRI.AZ.type]: (a, b) => a.membre.localeCompare(b.membre),
        [TRI.ZA.type]: (a, b) => b.membre.localeCompare(a.membre),
      }
      this.listeAmisAffichee.sort(strategiesDeTri[valeur])

      this.listeAmisAffichee = [...this.listeAmisAffichee]
    }
  }

  async modifierAmi(event) {
    const { id: idAmi } = event.detail,
      amiAModifier = this.listeAmis.find(({ id: idAmiDeMaListe }) => idAmiDeMaListe === idAmi)

    const resultat = await PopupBase.ouvrirEtAttendre("p-popup-ajout-ami", {
      commentaire: amiAModifier.commentaire,
    })

    if (resultat) {
      const { commentaire = "" } = resultat

      amiAModifier.commentaire = commentaire
      this.listeAmis = [...this.listeAmis]
      this.listeAmisAffichee = structuredClone(this.listeAmis)
      window.authentification.bdd.membres.ajouterOuModifierUnCommentaireSurUnMembre(idAmi, commentaire)
    }
  }

  async quitterCommunaute() {
    const optionsPopup = {
      titre: "Confirmer le départ de la communauté",
      texte: "Êtes-vous sûr de vouloir quitter cette communauté ?",
    }
    const resultat = await PopupBase.ouvrirEtAttendre("p-popup-confirmation", optionsPopup)
    if (resultat) {
      await window.authentification.bdd.communautes.supprimerUnMembreDuneCommunaute(this.idCommunaute, window.authentification.getUser().uid)
      naviguerVers("/communaute")
    }
  }

  async ajouterMessageAUneConversation(event) {
    const idAmi = event.detail.id
    const conversationsExistante = await window.authentification.bdd.conversation.recupererToutesLesConversationsDuMembreConnecte()
    const conversationExistante = conversationsExistante?.find((conversation) => conversation.participants.includes(idAmi))

    let idConversation

    if (conversationExistante) {
      idConversation = conversationExistante.id
    } else {
      idConversation = await window.authentification.bdd.conversation.creerUneConversation(idAmi)
    }

    naviguerVers(`/conversations/${idConversation}`)
  }
}

customElements.define("p-page-pokemons-a-echanger", PagePokemonsAEchanger)
